define.alias("ember-cli-clipboard/modifiers/clipboard", "media/modifiers/clipboard");